{
  "cc-flywheel-engagement.confluence-ai-daily-briefing.agenda.context": [
    {
      "type": 0,
      "value": "Context"
    }
  ],
  "cc-flywheel-engagement.confluence-ai-daily-briefing.agenda.meeting": [
    {
      "type": 0,
      "value": "Meeting"
    }
  ],
  "cc-flywheel-engagement.confluence-ai-daily-briefing.agenda.pre-read": [
    {
      "type": 0,
      "value": "Pre-read"
    }
  ],
  "cc-flywheel-engagement.confluence-ai-daily-briefing.agenda.time": [
    {
      "type": 0,
      "value": "Time"
    }
  ],
  "cc-flywheel-engagement.confluence-ai-daily-briefing.email.cta.go-to-confluence": [
    {
      "type": 0,
      "value": "Go to Confluence"
    }
  ],
  "cc-flywheel-engagement.confluence-ai-daily-briefing.email.footer.ai-disclaimer": [
    {
      "type": 0,
      "value": "This briefing was generated by Atlassian Intelligence based on your recent work activity."
    }
  ],
  "cc-flywheel-engagement.confluence-ai-daily-briefing.email.footer.manage-notifications": [
    {
      "type": 0,
      "value": "Manage notification preferences"
    }
  ],
  "cc-flywheel-engagement.confluence-ai-daily-briefing.email.footer.privacy-policy": [
    {
      "type": 0,
      "value": "Privacy policy"
    }
  ],
  "cc-flywheel-engagement.confluence-ai-daily-briefing.email.footer.sent-by": [
    {
      "type": 0,
      "value": "This email was sent by Atlassian"
    }
  ],
  "cc-flywheel-engagement.confluence-ai-daily-briefing.email.header.date": [
    {
      "type": 0,
      "value": "Your briefing for "
    },
    {
      "type": 1,
      "value": "briefingDate"
    }
  ],
  "cc-flywheel-engagement.confluence-ai-daily-briefing.email.header.greeting": [
    {
      "type": 0,
      "value": "Good morning, "
    },
    {
      "type": 1,
      "value": "userName"
    },
    {
      "type": 0,
      "value": " 👋"
    }
  ],
  "cc-flywheel-engagement.confluence-ai-daily-briefing.email.subject": [
    {
      "type": 1,
      "value": "userName"
    },
    {
      "type": 0,
      "value": ", here's your daily briefing for "
    },
    {
      "type": 1,
      "value": "briefingDate"
    }
  ],
  "confluence-editor-smart-links-draggable-changeboard.description": [
    {
      "type": 0,
      "value": "Organize your smart links and keep them in one place for quick access. Simply drag any smart link into your sidebar."
    }
  ],
  "confluence-editor-smart-links-draggable-changeboard.dismissButton": [
    {
      "type": 0,
      "value": "Got it"
    }
  ],
  "confluence-editor-smart-links-draggable-changeboard.gifAlt": [
    {
      "type": 0,
      "value": "Animation showing how to drag a smart link into the sidebar"
    }
  ],
  "confluence-editor-smart-links-draggable-changeboard.headline": [
    {
      "type": 0,
      "value": "Drag smart links to your sidebar"
    }
  ],
  "confluence-inline-reactions-mcu-nudge.description.many-reactions": [
    {
      "type": 1,
      "value": "user1"
    },
    {
      "type": 0,
      "value": ", "
    },
    {
      "type": 1,
      "value": "user2"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "type": 1,
      "value": "count"
    },
    {
      "type": 0,
      "value": " other"
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "s"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    },
    {
      "type": 0,
      "value": " reacted to this page"
    }
  ],
  "confluence-inline-reactions-mcu-nudge.description.no-reactions": [
    {
      "type": 0,
      "value": "Be the first one to react"
    }
  ],
  "confluence-inline-reactions-mcu-nudge.description.one-reaction": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " reacted to this page"
    }
  ],
  "confluence-inline-reactions-mcu-nudge.description.two-reactions": [
    {
      "type": 1,
      "value": "user1"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "type": 1,
      "value": "user2"
    },
    {
      "type": 0,
      "value": " reacted to this page"
    }
  ],
  "confluence-inline-reactions-mcu-nudge.title": [
    {
      "type": 0,
      "value": "Love this page? Let "
    },
    {
      "type": 1,
      "value": "authorName"
    },
    {
      "type": 0,
      "value": " know"
    }
  ],
  "post-office.confluence-resurrected-user-welcome-back.body": [
    {
      "type": 0,
      "value": "Catch up on the top discussions and highlights from your team."
    }
  ],
  "post-office.confluence-resurrected-user-welcome-back.close": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "post-office.confluence-resurrected-user-welcome-back.cta": [
    {
      "type": 0,
      "value": "See what's popular"
    }
  ],
  "post-office.confluence-resurrected-user-welcome-back.image-alt": [
    {
      "type": 0,
      "value": "Two hearts overlapped with each other"
    }
  ],
  "post-office.confluence-resurrected-user-welcome-back.next-best-action.header": [
    {
      "type": 0,
      "value": "Welcome back"
    }
  ]
}